export default {
  evaluation_dashboard: {
    unit: '社',
    average: '平均',
    point: '点',
    answered_label: '回答済',
    evaluated_label: '評価済',
    corporate_average: '被評価企業の平均スコア',
    points_earned_by_companies: '被評価企業の獲得点数分布',
    year_modal: {
      title: '対象年度を選択してください。',
      label: '対象年度',
    },
    response_status_title: '回答ステータス分布',
    response_status_rating_nothing: 'ESGレーティング評価済みの企業はありません。',
    esg_rating_title: 'ESGレーティング分布',
    esg_score_title: 'ESGスコア分布',
    category_scores_title: 'カテゴリ別スコア比較',
    category_scores_distribution_title: 'カテゴリ別スコア分布',
    category_score_data_all_label: '@:score_by_category_compared_section.esg_evaluated_all_companies_average',
    esg_scores_by_industry_title: '業種別ESGスコア分布',
    environment_score_title: '環境スコア分布',
    social_score_title: '社会スコア分布',
    governance_score_title: 'ガバナンススコア分布',
    environment_score_subtitle_upper5: '環境スコア 上位5社',
    environment_score_subtitle_lower5: '環境スコア 下位5社',
    social_score_subtitle_upper5: '社会スコア 上位5社',
    social_score_subtitle_lower5: '社会スコア 下位5社',
    governance_score_subtitle_upper5: 'ガバナンススコア 上位5社',
    governance_score_subtitle_lower5: 'ガバナンススコア 下位5社',
    empty_error_message: '調査票/サーベイがまだ発行されていません。',
    common: {
      update_date: '更新日時',
    },
    registration_rate: {
      title: '登録率',
      tip: '調査の対象社数に対しアスエネESGに登録している被評価企業数の割合',
    },
    answer_rate: {
      title: '回答率',
      tip: '調査の対象社数に対し回答を提出している被評価企業数の割合',
    },
    days_remaining: {
      title: '調査終了までの日数',
      tip: '設定された回答期限までの日数。\n回答期限を変更したい場合は、お問い合わせください。',
      days_remaining_before: '残り',
      days_remaining_after: '日',
      expired: '回答期限を超過しています',
    },
    answer_transition: {
      title: '回答推移',
      companies_submitted: '回答社数',
      breakdown: '内訳',
      unregistered: '未登録',
      total: '計',
      number_of_companies: '社数',
    },
    answer_list: {
      title: '最新の回答データ',
      submitted_at: '回答日時',
    },
    average_score: '平均スコア',
    risky_evaluation_comments: 'リスクのある評価コメント数',
    score_distribution: 'スコア分布',
    overall_score: '全体スコア',
    average_score_by_category: 'カテゴリ別平均スコア',
    score_ranking: 'スコアランキング',
    sort_by_lowest_score: 'スコアの低い順',
    sort_by_highest_score: 'スコアの高い順',
    high_risk_evaluation_comments: '高リスクの評価コメント',
  },
}